import { Heading, Text } from "@primer/react";
import "./FormContainer.css";

export function FormContainer({ children, className = "" }) {
  return <div className={`form-container ${className}`.trim()}>{children}</div>;
}

export function FormBody({ children, className = "" }) {
  return <div className={`form-body ${className}`.trim()}>{children}</div>;
}

export function FormHeader({ description, heading }) {
  return <header className="form-header"><Heading as="h2" className="text-section-heading">{heading}</Heading>{description ? <Text className="text-body muted-text">{description}</Text> : null}</header>;
}

export function FormFooter({ children, className = "", hasChanges = false }) {
  return <footer className={`form-footer${hasChanges ? " has-changes" : ""} ${className}`.trim()}>{children}</footer>;
}
